module.exports = __webpack_public_path__ + "img/refresh.67c7d792.png";